import { FormControl, FormItem, FormLabel, FormMessage } from "../../../../components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../components/ui/select";
import { usePrograms } from "../../../outreach/hooks/usePrograms";
interface OutreachProgramSelectProps {
  field: {
    value: string;
    onChange: (value: string) => void;
  };
}

export function OutreachProgramSelect({ field }: OutreachProgramSelectProps) {
  const { data: programs } = usePrograms({ status: "active" });

  // Ensure we have a valid string value for the Select
  const value = typeof field.value === 'string' ? field.value : '';

  return (
    <FormItem>
      <FormLabel>Outreach Program</FormLabel>
      <Select
        onValueChange={field.onChange}
        value={value}
      >
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder="Select program" />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {(programs ?? []).map((program) => {
            // Ensure we have a string value for SelectItem
            const id = program.id?.toString() ?? '';
            return (
              <SelectItem key={id} value={id}>
                {program.name}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  );
}
